const PanelTab = ({ onClick,isBackgroundWhite, title }) => {
  return (
    <button onClick={onClick} className={`rounded ${isBackgroundWhite?"border-2 border-primary":"border-none"} shadow-lg bg-white h-[60px] p-2 mx-3`}>
      {title}
    </button>
  );
};
export default PanelTab;
